import ListingPricesPreview from './ListingPricesPreview.component';

export default ListingPricesPreview;
